import React, { FunctionComponent, useEffect, useState } from 'react';
import { Presentation } from './presentation';
import { EventDetailProps as Props, EventDetailState } from './types';
import { getEventDetail } from '../../../services/events';

export const Component: FunctionComponent<Props> = (props) => {
  const { eventId, assetPaths, isPreview } = props;
  const [state, setState] = useState<EventDetailState>({
    data: null
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getEventDetail(eventId, isPreview)

        setState(prev => ({
          ...prev,
          data
        }));
      } catch (error) {
        console.error('Fetch Error:', error);
      }
    };
    fetchData();
  }, [eventId, isPreview]);

  return (
    <Presentation
      assetPaths={assetPaths}
      state={state}
    />
  );
};
